import * as Tone from 'tone';

/**
 * Thin wrapper over `Tone.context.currentTime` -- the playback store's
 * injectable/mockable audio-clock source (OTO-22). Kept as its own module
 * so store and hook tests can `vi.mock('@/utils/audioNow')` for a
 * deterministic clock without touching Tone itself.
 */
export function getAudioNow(): number {
  return Tone.context.currentTime;
}
